export const actions = {
  async nuxtServerInit({ dispatch }) {
    await dispatch('navigation/load')
    await dispatch('content/loadCookieBanner')
    await dispatch('content/loadGlobalLinks')
    await dispatch('applicationForms/user/fetchUser')
  },
}
